import React from 'react'


const About = () => {
    return (
        <div className='text-3xl text-white'>
            The quick brown fox jumps over the lazy dog
        </div>
    )
}

export default About